export const CONSTANTS = {
  APP_WHITE_LOGO_URL: 'https://res.cloudinary.com/hellojoy/image/upload/v1747362671/Logos/white_logo_nav.png'
}